<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <div class="box clearfix">
          <div class="box-icon">
            <span class="flaticon flaticon-summer"></span>
          </div>
          <div class="box-text">
            <h2>{{$t('quality')}}</h2>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="box clearfix">
          <div class="box-icon">
            <span class="flaticon flaticon-summer"></span>
          </div>
          <div class="box-text">
            <h2>{{$t('integrity')}}</h2>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="box clearfix">
          <div class="box-icon">
            <span class="flaticon flaticon-summer"></span>
          </div>
          <div class="box-text">
            <h2>{{$t('socialValue')}}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NosValeurs"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 33px 0;
  border: 2px dashed #64a507;
  border-radius: 10px;
  margin-bottom: 30px;
}
.box-icon {
  border-radius: 0;
  display: block;
  width: 80px;
  height: 80px;
  background: #ffffff;
  border-radius: 50%;
  padding: 5px;
}

.box-icon span {
  background: transparent;
  border: none;
  border-radius: 0;
  display: block;
  text-align: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.box-icon span:before {
  display: block;
  margin: 20px 0 0 0;
  color: #64a507;
  font-size: 55px !important;
}

.box-text {
  margin-left: 25px;
}
.box-text p {
  color: #202020;
  font-size: 19px;
  font-weight: 300;
}
.box-text h2 {
  color: #202020;
  letter-spacing: 3px;
  font-size: 19px;
  font-weight: 700;
  text-transform: uppercase;
}
.box-icon {
  display: block;
  width: 80px;
  height: 80px;
  background: #ffffff;
  border-radius: 50%;
  padding: 5px;
}
</style>
